
<div class="row">
  @if(this.isCompany == true) {
    <div class="row">
      <div class="col d-flex align-items-start gap-2">
      <div class="flex-grow-1" style="min-width: 0;">
        <ul ngbNav #ArrowNgbNav="ngbNav" [(activeId)]="activeId" (navChange)="onTabChange($event)" class="nav nav-pills arrow-navtabs nav-success bg-light mb-3">
          <li [ngbNavItem]="navItemLog_Usage">
            <a ngbNavLink>
              <span class="d-sm-block">Usage</span>
            </a>
            <ng-template ngbNavContent>
                ...Usage...
            </ng-template>
          </li>
          <li [ngbNavItem]="navItemLog_Country" *ngIf="featureEnabledCountryPlans">
            <a ngbNavLink>
              <span class="d-sm-block">Country</span>
            </a>
            <ng-template ngbNavContent>
                ...Country...
            </ng-template>
          </li>
        </ul>
      </div>
      <div class="flex-shrink-0 alert-header-actions">
        <div class="hstack gap-2 justify-content-end">
          <!-- Company Add Alert Icon -->
          <div class="list-inline-item edit me-0">
            <a href="javascript:void(0);" class="text-black d-flex edit-item-btn" id="add-btn" (click)="addAlert()">
              <i class="ri-add-fill fs-18 border rounded alert-header-icon-btn" style="border-color:'#767676;'" tooltipClass="custom-tooltip-sucess" [ngbTooltip]="showTooltips ? addAlertToolTipText : null"></i>



            </a>
          </div>
          @if (showLocationWebhook) {
            <div class="list-inline-item edit">
              <a href="javascript:void(0);" class="text-black d-flex edit-item-btn" id="add-webhook-btn" (click)="addWebhook()">
                <i class="mdi mdi-webhook fs-18 border rounded alert-header-icon-btn" style="border-color:'#767676;'" tooltipClass="custom-tooltip-sucess" [ngbTooltip]="showTooltips ? 'Location Webhook Endpoint' : null"></i>
              </a>
            </div>
          }
        </div>
      </div>
      </div>
    </div>
  }
  <div class="row perfect-scrollbar" *ngIf="alerts.length > 0; else noAlerts">
    <div class="col-4" *ngFor="let alert of alerts">
      <div class="card card-animate alert-tile" [style.border-top-color]="'var(--vz-' + alertAccent(alert) + ')'" *ngIf="isCompany; else deviceAlert">
        <div class="card-body">
          <div class="d-flex">
            <div class="flex-grow-1 overflow-hidden">
              <p class="fs-14 text-uppercase fw-medium text-muted text-truncate mb-0">{{alert.alertType}}</p>
            </div>
            <div class="flex-shrink-0">
              <!-- Comapny Icons -->
              <div class="list-inline-item edit">
                <a href="javascript:void(0);" class="text-primary d-inline-block edit-item-btn" id="create-btn" (click)="editAlert(alert.id)">
                  <i class="ri-pencil-fill fs-16"></i>
                </a>
              </div>
              <div class="list-inline-item delete">
                <a href="javascript:void(0);" class="text-primary d-inline-block delete-item-btn" id="delete-btn" (click)="deleteAlert(alert.id)">
                  <i class="ri-delete-bin-fill text-danger"></i>
                </a>
              </div>
              @if (!alert.active) {
              <div class="list-inline-item delete">
                <a href="javascript:void(0);" class="text-primary d-inline-block delete-item-btn" id="active-btn" (click)="enableAlert(alert.id)">
                  <i class="las la-toggle-off text-danger"></i>
                </a>
              </div>
              }
              @if (alert.active) {
              <div class="list-inline-item delete">
                <a href="javascript:void(0);" class="text-primary d-inline-block delete-item-btn" id="active-btn" (click)="disableAlert(alert.id)">
                  <i class="las la-toggle-on text-success"></i>
                </a>
              </div>
              }
            </div>
          </div>
          <div class="d-flex align-items-end justify-content-between mt-2">
            <div>
              <h4 class="fs-16 fw-semibold ff-secondary">
                <span>{{alert.name}}</span>
              </h4>                                      
            </div>
          </div>
          @if (activeId == navItemLog_Usage) {
            <div class="d-flex col-12 mt-0">
              <p class="fs-12 mb-1 text-align-left text-muted">
                <span><strong>Threshold: </strong>{{alert.threshold! | alertThreshold: alert.alertType!}}</span>
              </p>
            </div>
          } @else {
            <div class="d-flex col-12 mt-0">
              <p class="fs-12 mb-1 text-align-left text-muted">
                <span><strong>Countries Covered: </strong>{{alert.countryCount!}}</span>
              </p>
            </div>
            <div class="d-flex col-12 mt-0">
              <p class="fs-12 mb-1 text-align-left text-muted">
                <span><strong>Countries Not Covered: </strong>{{alert.countryAvailableCount!}}</span>
              </p>
            </div>
          }
          <div class="d-flex col-12 mt-0">
            <p class="fs-12 mb-1 text-align-left text-muted">
              <span><strong>Delivery: </strong>{{alert.deliveryMethod}}</span>
            </p>
          </div>
          @if(activeId == navItemLog_Usage) {
          <div class="d-flex col-12 text-break">
            @if(alert != undefined && alert.action != undefined && getTextWidth(alert.action, '12px Arial') > maxActionPxLength) {
              <p class="fs-12 text-align-left text-muted mb-0 mt-0">
                <span><strong>Action: </strong>{{alert.action}}</span>
              </p>
            } @else {
              <p class="fs-12 text-align-left text-muted mt-0">
                <span><strong>Action: </strong>{{alert.action}}</span>
              </p>
            }
          </div>
          } 
          @if(!alert.defaultTemplate && !alert.addOnCompanyCreation && (activeId == navItemLog_Usage)) {
            @if(alert != undefined && alert.action != undefined && getTextWidth(alert.action, '12px Arial') > maxActionPxLength) {
            <div class="d-flex align-items-end justify-content-between mb-0 mt-1">
              <div class="col-6">
                <h5 class="fs-12 text-success">
                  <span>{{alert.optInCount}} Opted In</span>
                </h5>              
              </div>
              <div class="col-6">
                <h5 class="fs-12 text-danger text-align-right">
                  <span>{{alert.optOutCount}} Opted Out</span>
                </h5>
              </div>
            </div>
            } @else {
            <div class="d-flex align-items-end justify-content-between mt-1">
              <div class="col-6">
                <h5 class="fs-12 text-success">
                  <span>{{alert.optInCount}} Opted In</span>
                </h5>              
              </div>
              <div class="col-6">
                <h5 class="fs-12 text-danger text-align-right">
                  <span>{{alert.optOutCount}} Opted Out</span>
                </h5>
              </div>
            </div>
            }
          }
          @if(!alert.defaultTemplate && !alert.addOnCompanyCreation && (activeId != navItemLog_Usage)) {
            <div class="d-flex align-items-end justify-content-between mt-1">
              <div class="col-12">
                <h5 class="fs-12 text-warning">
                  <span>&nbsp;</span>
                </h5>              
              </div>
            </div>
          }
          @if(alert.defaultTemplate) {
            <div class="d-flex align-items-end justify-content-between mt-1">
              <div class="col-12">
                <h5 class="fs-12 text-warning">
                  <span>Template - No Alerting</span>
                </h5>              
              </div>
            </div>
          }
          @if(alert.addOnCompanyCreation) {
            <div class="d-flex align-items-end justify-content-between mt-1">
              <div class="col-12">
                <h5 class="fs-12 text-info">
                  <span>Default Alert - No Alerting</span>
                </h5>              
              </div>
            </div>
          }
        </div>
      </div>
      <ng-template #deviceAlert>
        <div class="card card-animate alert-tile" [style.border-top-color]="'var(--vz-' + alertAccent(alert) + ')'">
          <div class="card-body">
          <div class="d-flex">
            <div class="flex-grow-1 overflow-hidden">
              <p class="fs-14 text-uppercase fw-medium text-muted text-truncate mb-0">{{alert.alertType}}</p>
            </div>
            <div class="flex-shrink-0">
              <!-- Sim Icons -->
              <div class="list-inline-item edit">
                <a href="javascript:void(0);" class="text-danger d-inline-block edit-item-btn" id="optOut-btn" (click)="optOutAlert(alert.id)">
                  <i class="ri-close-fill fs-16" tooltipClass="custom-tooltip-danger" [ngbTooltip]="showTooltips ? 'Opt out' : null"></i>
                </a>
              </div>
            </div>
          </div>
            <div class="d-flex col-12 mt-2">
              <h4 class="fs-16 fw-semibold ff-secondary mb-4">
                <span>{{alert.name}}</span>
              </h4>                                      
            </div>
            
            <div class="d-flex col-12 mt-1">
              <p class="fs-12 mb-1 text-align-left text-muted">
                <span><strong>Threshold: </strong>{{alert.threshold! | alertThreshold: alert.alertType!}}</span>
              </p>
            </div>
            <div class="d-flex col-12">
              <p class="fs-12 mb-1 text-align-left text-muted">
                <span><strong>Delivery: </strong>{{alert.deliveryMethod}}</span>
              </p>
            </div>
            @if(alert != undefined && alert.action != undefined && getTextWidth(alert.action, '12px Arial') > maxActionPxLength) {
              <div #{{sdfsd}} class="d-flex col-12">
                <p class="fs-12 text-align-left text-muted mb-0 mt-0">
                  <span><strong>Action: </strong>{{alert.action}}</span>
                </p>
              </div>
            } @else {
              <div class="d-flex col-12">
                <p class="fs-12 text-align-left text-muted">
                  <span><strong>Action: </strong>{{alert.action}}</span>
                </p>
              </div>
            }
            <div class="d-flex col-12">
              <div class="col-6">
                <h5 class="fs-12 mb-0" [ngClass]=" {'text-success': (!alert.optOut && (alert.optIn || alert.allSims)), 'text-danger': alert.optOut}">
                  <span *ngIf="alert.optOut == true">Opted Out</span>
                  <span *ngIf="!alert.optOut && (alert.optIn == true || alert.allSims)">Opted In</span>
                </h5>
              </div>
              <div class="col-6">
                <div class="hstack gap-2 justify-content-end">
                  <!-- Company Add Alert Icon -->
                  <div class="list-inline-item edit">
                    <i class="fs-16 text-danger">&nbsp;</i>
                    @if(alert != undefined && alert.action != undefined && alert.triggeredActive) {
                      <i class="bx bx-bell fs-16 text-danger" tooltipClass="custom-tooltip-danger" container="body" [ngbTooltip]="showTooltips ? 'Alert is active' : null"></i>
                    }
                    <i class="fs-16 text-danger">&nbsp;</i>
                    @if(alert != undefined && alert.action != undefined && alert.triggeredCount != undefined && alert.triggeredCount == 1 && alert.action.indexOf('Inc.') == -1) {
                      <i class="ri-alert-fill fs-16 text-danger" tooltipClass="custom-tooltip-danger" container="body" [ngbTooltip]="showTooltips ? 'Triggered this month' : null"></i>
                    }
                    @if(alert != undefined && alert.action != undefined && alert.triggeredCount != undefined && alert.triggeredCount == 1 && alert.action.indexOf('Inc.') >= 0) {
                      <i class="ri-alert-fill fs-16 text-danger" tooltipClass="custom-tooltip-danger" container="body" [ngbTooltip]="showTooltips ? 'Triggered 1 time this month' : null"></i>
                    }
                    @if(alert != undefined && alert.action != undefined && alert.triggeredCount != undefined && alert.triggeredCount > 1) {
                      <i class="ri-alert-fill fs-16 text-danger" tooltipClass="custom-tooltip-danger" container="body" [ngbTooltip]="showTooltips ? 'Triggered ' + alert.triggeredCount + ' times this month' : null"></i>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      
    </div>
  </div>
  <ng-template #noAlerts>
    <div class="col-12">
      <p class="text-uppercase fw-medium text-muted text-truncate mb-0">No Alerts Found </p>
    </div>
  </ng-template>
</div>


<app-alert-modal-edit-form #alertModalForm
  [initialCompanyId]="companyId"
  (alertFormCancelled)="alertClosed()"
  (alertDataHasBeenSaved)="alertSaved()"
></app-alert-modal-edit-form>

<app-confirmation-modal-form #deleteConfirmationModal
  (modalYes)="yesDeleteAlert()"
></app-confirmation-modal-form>

<app-confirmation-modal-form #optOutConfirmationModal
  (modalYes)="yesOptOutAlert()"
></app-confirmation-modal-form>

<app-confirmation-modal-form #toggleConfirmationModal
  (modalYes)="yesToggleAlert()"
></app-confirmation-modal-form>

<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>

<app-information-modal-form #informationModalForm
></app-information-modal-form>

<app-location-webhook-modal-form #locationWebhookModalForm
  [initialCompanyId]="companyId"
></app-location-webhook-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
